<template>
  <form ref="formulario" novalidate>
    <!-- Aquí se renderizarán todos los inputs -->
    <slot></slot>
  </form>
</template>
<script>
/** Clase que se agrega al formulario para mostrar feedback de validación */
const CLASE_FORMULARIO_VALIDO = "was-validated";
export default {
  methods: {
    /** Devuelve verdadero si el formulario principal es válido,
     * es decir, que no faltan campos por rellenar
     */
    esValido() {
      return this.$refs.formulario.checkValidity();
    },
    limpiarFeedback() {
      // Limpia el formulario si había feedback de validación anterior
      this.$refs.formulario.classList.remove(CLASE_FORMULARIO_VALIDO);
    },
    mostrarFeedback() {
      // Agregar clase para indicar que el formulario fue validado y mostrar feedback
      this.$refs.formulario.classList.add(CLASE_FORMULARIO_VALIDO);
    },
  },
};
</script>